import React from 'react'
import { useField } from 'formik'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Slider } from '@material-ui/core'
import { mapObjIndexed } from 'ramda'
import {
  RANGE_STEP,
  RANGE_MIN,
  RANGE_MAX,
  RANGE_1_INDEX,
  RANGE_2_INDEX,
  RANGE_3_INDEX,
  RANGE_4_INDEX,
  RANGE_5_INDEX,
  RANGE_6_INDEX,
  RANGE_7_INDEX,
  RANGE_8_INDEX,
  RANGE_1_VALUE,
  RANGE_2_VALUE,
  RANGE_3_VALUE,
  RANGE_4_VALUE,
  RANGE_5_VALUE,
  RANGE_6_VALUE,
  RANGE_7_VALUE,
  RANGE_8_VALUE,
  rangeOfBeacon,
} from 'app/constants/beacon'

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  sliderStyle: {
    width: '100%',
    '& .MuiSlider-mark': {
      width: '7px',
      height: '7px',
      position: 'absolute',
      borderRadius: '50%',
      margin: '-3px !important',
      backgroundColor: '#a8a8a8',
    },
    '& .MuiSlider-markActive': {
      backgroundColor: '#0073b1',
      opacity: 1,
    },
    '& .MuiSlider-track': {
      height: '1px',
      backgroundColor: '#0073b1',
    },
    '& .MuiSlider-thumb': {
      width: '7px',
      height: '7px',
      margin: '-3px !important',
    },
    '& .MuiSlider-rail': {
      height: '1px',
      backgroundColor: '#e5e5e5',
    },
    '& .MuiSlider-markLabel': {
      fontSize: '12px',
      color: '#a8a8a8',
    },
  },
}))

const getMarks = (unit) => {
  const mapValue = mapObjIndexed((item, index) => {
    return { value: parseInt(index) + 1, label: `${item}${unit}` }
  }, rangeOfBeacon[unit])

  return Object.values(mapValue)
}

const mapSliderValueToRange = {
  [RANGE_1_INDEX]: RANGE_1_VALUE,
  [RANGE_2_INDEX]: RANGE_2_VALUE,
  [RANGE_3_INDEX]: RANGE_3_VALUE,
  [RANGE_4_INDEX]: RANGE_4_VALUE,
  [RANGE_5_INDEX]: RANGE_5_VALUE,
  [RANGE_6_INDEX]: RANGE_6_VALUE,
  [RANGE_7_INDEX]: RANGE_7_VALUE,
  [RANGE_8_INDEX]: RANGE_8_VALUE,
}

const mapRangeToSliderValue = {
  [RANGE_1_VALUE]: RANGE_1_INDEX,
  [RANGE_2_VALUE]: RANGE_2_INDEX,
  [RANGE_3_VALUE]: RANGE_3_INDEX,
  [RANGE_4_VALUE]: RANGE_4_INDEX,
  [RANGE_5_VALUE]: RANGE_5_INDEX,
  [RANGE_6_VALUE]: RANGE_6_INDEX,
  [RANGE_7_VALUE]: RANGE_7_INDEX,
  [RANGE_8_VALUE]: RANGE_8_INDEX,
}

const BeaconRange = (props) => {
  const { name, unit, onChange } = props
  const [field, meta, helpers] = useField(name) // Formik hook
  const { setValue } = helpers
  const currentRange = field.value // Use field value from Formik
  const classes = useStyles()
  const marks = getMarks(unit)

  const handleRangeChange = (event, newValue) => {
    const result = mapSliderValueToRange[newValue]

    if (onChange) {
      onChange(result)
    }
    setValue(result) // Update Formik value
  }

  return (
    <div className={classes.root}>
      <div className="flex justify-between py-5"></div>
      <div className="flex justify-between">
        <div className="w-full px-5">
          <Slider
            role="slider"
            value={mapRangeToSliderValue[currentRange] || RANGE_1_INDEX}
            onChange={handleRangeChange}
            className={classes.sliderStyle}
            aria-labelledby="discrete-slider-small-steps"
            step={RANGE_STEP}
            marks={marks}
            min={RANGE_MIN}
            max={RANGE_MAX}
          />
        </div>
      </div>

      {meta.touched && meta.error && (
        <div className="text-red-500 text-sm mt-2">{meta.error}</div>
      )}
    </div>
  )
}

BeaconRange.propTypes = {
  name: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  onChange: PropTypes.func,
}

export default BeaconRange
